import { StatusBadge } from "@/components/status-badge";
import type { StatusKey } from "@/components/status-badge";

type JobStatus =
  | "pending"
  | "processing"
  | "ready_for_review"
  | "completed"
  | "failed";

interface JobStatusBadgeProps {
  status: JobStatus;
  className?: string;
}

const jobStatusConfig: Record<
  JobStatus,
  { status: StatusKey; label: string; showSpinner?: boolean }
> = {
  pending: {
    status: "pending",
    label: "Pending",
    showSpinner: true,
  },
  processing: {
    status: "processing",
    label: "Processing",
    showSpinner: true,
  },
  ready_for_review: {
    status: "review",
    label: "Ready For Review",
    showSpinner: false,
  },
  completed: {
    status: "completed",
    label: "Completed",
    showSpinner: false,
  },
  failed: {
    status: "error",
    label: "Failed",
    showSpinner: false,
  },
};

export function JobStatusBadge({ status, className }: JobStatusBadgeProps) {
  const config = jobStatusConfig[status];

  return (
    <StatusBadge
      status={config.status}
      label={config.label}
      showSpinner={config.showSpinner}
      className={className}
    />
  );
}
